import { isMobile, isMobileOnly } from 'mobile-device-detect';
var dateFormat = require('dateformat');

const getters = {
  controlsNeedRefresh: state => {
    return state.controlsNeedRefresh
  },

  isMobile: state => {
    return isMobileOnly;
  },

  idCompany: state => {
    return state.tokenService.idCompany();
  },
  companyName: state => {
    return state.tokenService.companyName();
  },
  companyTypePublicCode: state => {
    return state.tokenService.companyTypePublicCode();
  },
  companyEnergies: state => {
    return state.tokenService.companyEnergies();
  },
  companyUnits: state => {
    return state.companyUnits;
  },
  idUser: state => {
    return state.tokenService.idUser();
  },
  idRole: state => {
    return state.tokenService.idRole();
  },

  isSuperAdmin: state => {
    return state.tokenService.isSuperAdmin();
  },
  isAdmin: state => {
    return state.tokenService.isAdmin();
  },
  isEnergyCompany: state => {
    return state.tokenService.isEnergyCompany();
  },
  isAdminEnergyCompany: state => {
    return state.tokenService.isAdminEnergyCompany();
  },
  isSuperUser: state => {      
    return state.tokenService.isSuperUser();
  },
  isUser: state => {      
    return state.tokenService.isUser();
  },
  isSimpleUser: state => {      
    return state.tokenService.isSimpleUser();
  },

  isColdWaterPermission() {
    return state.tokenService.isColdWaterPermission();
  },
  isHotWaterPermission() {
    return state.tokenService.isHotWaterPermission();
  },
  isHeatPermission() {
    return state.tokenService.isHeatPermission();
  },
  isElectricityPermission() {
    return state.tokenService.isElectricityPermission();
  },
  isGasPermission() {
    return state.tokenService.isGasPermission();
  },

  getDateFormatByPeriodCode: state => (date, publicCode) => {
    if (publicCode == 'month') {
      //return dateFormat(date, 'yyyy mmmm')
      return dateFormat(date, 'yyyy-mm-dd')
    }
    if (publicCode == 'week') {
      return dateFormat(date, 'yyyy-mm-dd')
    }
    else if (publicCode == 'day') {
      return dateFormat(date, 'yyyy-mm-dd')
    }
    else if (publicCode == 'hour') {
      return dateFormat(date, 'yyyy-mm-dd [HH]')
    }
    else {
      return dateFormat(date, 'yyyy-mm-dd HH:MM')
    }
  },

  getVariantConnectionDate: state => (lastActiveTime) => {
    let date = new Date(lastActiveTime)

    var t1 = new Date().getTime()
    var t2 = date.getTime()

    let diffDays = Math.floor((t1-t2)/(24*3600*1000))

    if (diffDays < 0) {
      diffDays = diffDays * -1
    }

    if (diffDays > 14) return 'danger'

    if (diffDays > 7) return 'warning'

    return 'success'
  },

  getElapsedTime: state => (lastActiveTime) => {
    if (!lastActiveTime) return ''

    let date = new Date(lastActiveTime)

    var t1 = new Date().getTime()
    var t2 = date.getTime()
    var ms = t1-t2

    let diffYears = Math.floor(ms/(365*24*60*60*1000))
    let diffDays = Math.floor(ms/(24*60*60*1000))
    let diffHours = Math.floor(ms/(60*60*1000))
    let diffMinutes = Math.floor(ms/(60*1000))
    let diffSeconds = Math.floor(ms/(1000))

    if (diffYears > 0) {
      return `${diffYears} г. ${diffDays - diffYears*365} дн. назад`
    }

    if (diffDays > 0) {
      return `${diffDays} дн. ${diffHours - diffDays*24} час. назад`
    }

    if (diffHours > 0) {
      return `${diffHours} час. ${diffMinutes - diffHours*60} мин. назад`
    }

    if (diffMinutes > 0) {
      return `${diffMinutes} мин. назад`
    }

    return `${diffSeconds} сек. назад`

  },

  getColorByEnergyType: state => (publCod, index) => {
    if (index == null) index = 0;
    switch(publCod) {
      case 'cold_water_meters':
      case 'cold_water_flow_meters':
      case 'cold_water_pressure_meters':
        if (index > state.colors.coldWaterMeters.length-1) {
          index = state.colors.coldWaterMeters.length-1;
        }
        return state.colors.coldWaterMeters[index];
      case 'hot_water_meters':
        if (index > state.colors.hotWaterMeters.length-1) {
          index = state.colors.hotWaterMeters.length-1;
        }
        return state.colors.hotWaterMeters[index];
      case 'heat_meters':
        if (index > state.colors.heatMeters.length-1) {
          index = state.colors.heatMeters.length-1;
        }
        return state.colors.heatMeters[index];
      case 'gas_meters':
        if (index > state.colors.gasMeters.length-1) {
          index = state.colors.gasMeters.length-1;
        }
        return state.colors.gasMeters[index];
      case 'electricity_meters':
        if (index > state.colors.electricityMeters.length-1) {
          index = state.colors.electricityMeters.length-1;
        }
        return state.colors.electricityMeters[index];
    }

    return '#607D8B'
  }
}

export default getters